import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PortfolioProvider } from "./context/PortfolioContext";
import { QuotesProvider } from "./context/QuotesContext";
import Dashboard from "./pages/Dashboard";
import Editor from "./pages/Editor";
import PortfolioView from "./pages/PortfolioView";
import QuotesList from "./pages/QuotesList";
import QuoteBuilder from "./pages/QuoteBuilder";
import Muestras from "./pages/Muestras";
import Admin from "./pages/Admin";
import HostGate from "./components/HostGate";
import ThankYou from "./pages/ThankYou";
import Platforms from "./pages/Platforms";
import CrmApp from "./pages/crm/CrmApp";
import StoreShell from "./pages/market/StoreShell";
import Storefront from "./pages/market/Storefront";
import Cart from "./pages/market/Cart";
import OrderPage from "./pages/market/OrderPage";
import MyOrders from "./pages/market/MyOrders";
import StoreAdmin from "./pages/market/StoreAdmin";
import { Toaster } from "./components/ui/toaster";
import TapRipple from "./components/TapRipple";

function App() {
  return (
    <div className="App">
      <PortfolioProvider>
        <QuotesProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HostGate><Dashboard /></HostGate>} />
              <Route path="/editor/:id" element={<Editor />} />
              <Route path="/p/:slug" element={<PortfolioView />} />
              <Route path="/cotizaciones" element={<QuotesList />} />
              <Route path="/cotizacion/:id" element={<QuoteBuilder />} />
              <Route path="/muestras" element={<Muestras />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/plataformas" element={<Platforms />} />
              <Route path="/c/:slug" element={<CrmApp />} />
              <Route path="/m/:slug/admin" element={<StoreAdmin />} />
              <Route path="/m/:slug" element={<StoreShell />}>
                <Route index element={<Storefront />} />
                <Route path="carrito" element={<Cart />} />
                <Route path="pedido/:oid" element={<OrderPage />} />
                <Route path="mis-pedidos" element={<MyOrders />} />
              </Route>
              <Route path="/p/:slug/gracias" element={<ThankYou />} />
              <Route path="/:domain/:slug/gracias" element={<ThankYou />} />
              <Route path="/:domain/:slug" element={<PortfolioView />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
          <TapRipple />
        </QuotesProvider>
      </PortfolioProvider>
    </div>
  );
}

export default App;
